import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useIsLawyer } from 'Hooks/useIsLawyer';
import { Disconnect, MiniBurger, ToInfo } from 'Images';

export const MenuOutro = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MobileMenu);
  const { instance, inProgress } = useMsal();

  const isLawyer = useIsLawyer();

  return (
    <Stack direction='column' gap='20px' sx={{ margin: '72px 0 100px 0' }}>
      {!isLawyer && (
        <>
          <Button
            sx={{
              p: 0,
              width: 'fit-content',
              justifyContent: 'flex-start',
              gap: '10px',
            }}
            href='/activities-lobby'
          >
            <Avatar
              sx={{ width: '20px', height: '20px' }}
              src={MiniBurger}
              alt=''
            />
            <Typography variant='body6' color='initial'>
              {dictionary.fullActionList}
            </Typography>
          </Button>
          <Button
            sx={{
              p: 0,
              width: 'fit-content',
              justifyContent: 'flex-start',
              gap: '10px',
            }}
            href={import.meta.env.VITE_APP_MARKETING_SITE_URL}
          >
            <Avatar
              sx={{ width: '20px', height: '20px' }}
              src={ToInfo}
              alt=''
            />
            <Typography variant='body6' color='initial'>
              {dictionary.toInfo}
            </Typography>
          </Button>
        </>
      )}
      <Button
        sx={{
          p: 0,
          width: 'fit-content',
          justifyContent: 'flex-start',
          gap: '10px',
        }}
        onClick={async () => {
          if (inProgress === InteractionStatus.None) {
            sessionStorage.removeItem('B2CToken');
            sessionStorage.removeItem('token');
            await instance.logoutRedirect();
          }
        }}
        role='link'
      >
        <Avatar
          sx={{ width: '20px', height: '20px' }}
          src={Disconnect}
          alt=''
        />
        <Typography variant='body5' color='purple2.main'>
          {dictionary.disconnect}
        </Typography>
      </Button>
    </Stack>
  );
};
